__turbopack_context__.v({
  "chapter": "WcJOea_chapter",
  "chapterTitle": "WcJOea_chapterTitle",
  "separator": "WcJOea_separator",
});
